angular.module('admin')

  .factory('AuthForwarder', ['$cookies', '$state', 'AccountService', 'SessionService', 'APP_CONFIG', function($cookies, $state, AccountService, SessionService, APP_CONFIG){
    const COOKIE_NAME = 'redirectAfterAuthSuccess';

    let service = {
      forwardAfterLogin(){
        let forwardState = $cookies.getObject(COOKIE_NAME);

        if(forwardState){
          $cookies.remove(COOKIE_NAME);

          // disable forwarder while we fix login issues
          // if(forwardState.name.indexOf('login') !== -1 && forwardState.name.indexOf('start') !== -1) // temporary, we can delete this line soon, but leave next line
          //   $state.go(forwardState.name, forwardState.params);

          // return;
        }

        if(AccountService.getAgent('state') === 'active') {
          $state.go('agent.stream', {id: AccountService.getAgentId()});
        } else {
          $state.go('agent.onboarding');
        }
      },

      // if a user has a bad token and gets sent to the login
      // save the state they were trying to access as a cookie
      setForwardState(url){
        if(url && url.indexOf('login') === -1 && url.indexOf('start') === -1){
          $cookies.putObject(COOKIE_NAME, url, {
            domain: APP_CONFIG.COOKIE_DOMAIN,
            path:'/',
            expires: moment().add(2, 'hours').format()
          });
        }
      },
    };

    return service;
  }]);
